/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";
import { Fragment } from "@wordpress/element";
import { registerFormatType, toggleFormat } from "@wordpress/rich-text";
import { RichTextToolbarButton } from '@wordpress/block-editor';
import React from "react";

/**
 * Block constants
 */
const name = 'advanced/highlight';

export const highlight = {
	name,
	title: __( 'Highlight' ),
	tagName: 'span',
	className: null,
	attributes: {
		style: 'style',
	},
	edit( { isActive, value, onChange } ) {
		const onToggle = () => {
			onChange(
				toggleFormat( value, {
					type: name,
					attributes: {
						style: 'box-shadow: inset 0px -0.6em 0px #00ABE8;',
					},
				} ) 
			);
		};
		return (
			<Fragment>
				<RichTextToolbarButton
					icon="editor-highlight"
					title={ __( 'Highlight' ) }
					onClick={ onToggle }
					isActive={ isActive }
				/>
			</Fragment>
		);

	},
};

export default function() {
	[
		highlight,
	].forEach( ( { name, ...settings } ) => registerFormatType( name, settings ) );
};
